//
//
//
//
//
//
//
//
//
//
//
//

import WCAG from '@/scripts/libs/wcag/wcag'
import { TRACKER_HIDDEN_ACTION, TRACKER_CLICK } from '@/scripts/constants/tracker'
export default {
  name: 'rb-pill',
  props: {
    size: {
      type: String,
      default: 'medium', // options: ['xsmall', 'small', 'medium', 'large']
    },
    color: {
      type: String,
      default: 'black', // options: ['black', 'red', 'white', 'invisible', 'light-gray']
    },
    dataElementId: {
      type: String,
      default: '',
    },
    dataDescription: {
      type: String,
      default: '',
    },
    cursor: {
      type: String,
      default: 'pointer', // options: ['pointer', 'arrow']
    },
    type: {
      type: String,
      default: 'normal', // options: ['normal', 'filter', 'ddm']
    },
    role: {
      type: String,
      default: '',
    },
    tabindex: {
      type: String,
      default: '-1',
    },
  },
  computed: {
    getPillSize() {
      return `rb-pill--${this.size}`
    },
    getPillColor() {
      return `rb-pill--${this.color}`
    },
    getPillCursor() {
      return `rb-pill--cursor-${this.cursor}`
    },
    getPillType() {
      return `rb-pill--${this.type}`
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
      this.$ma.trackEvent({
        Tracking_Type: TRACKER_HIDDEN_ACTION,
        event: TRACKER_CLICK,
        value: {
          data_element_id: this.dataElementId,
          data_description: this.dataDescription,
        },
      })
    },
    onKeyPress(e) {
      if (WCAG.isEnterPressed(e)) {
        this.onClick()
      }
    },
  },
}
